<template>
  <div id="defaultId1" class="defBord">
    <el-dialog id="idpfCClW" class="defBord" :title="$t('增加税率')" :visible.sync="dialogVisible" @close="dialogFormVisible"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form id="idez97UO" class="defBord" size="small" style="width: 70%;margin: 20px auto" :model="form"
        :rules="formRules" ref="form">
        <el-form-item id="id1RddrE" class=" defBord  " :label="$t('税率分类')" prop="name" :label-width="formLabelWidth"
          :rules="[{ required: true, message: $t('请输入税率分类') }]" style="margin-bottom: 30px">
          <el-input v-model="form.name" autocomplete="off" style="width: 60%" :placeholder="$t('请输入税率分类')"></el-input>
          <div class="form-item-hint">{{$t('自定义名称，仅用于商家自己区分分类，不会展示给顾客')}}</div>
        </el-form-item>
        <el-form-item id="idVViJLx" class=" defBord  " :label="$t('税率')" prop="rate" :label-width="formLabelWidth"
          :rules="[{ required: true, message: $t('请输入税率值') }, { pattern: /^\d+(\.\d+)?$/, trigger: 'blur', message:$t('请输入数字')  }]">
          <el-input id="idg6Thvg" style="width: 20%" class="defBord" v-model="form.rate" autocomplete="off">
          </el-input>%
        </el-form-item>
        <el-form-item :label="$t('适用菜品分类')" prop="category_id" :rules="[{ required: true, message: $t('请选择菜品分类') }]"
                      :label-width="formLabelWidth">
          <el-checkbox-group v-model="form.category_id">
            <el-checkbox v-for="item in storeList" :key="item.category_id" :label="item.category_id + ''" :disabled="extistCategory.includes(item.category_id)">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div id="idtx1un1" class="dialog-footer defBord" slot="footer">
        <el-button id="idXjhGlW" @click="dialogFormVisible" class="defBord">{{ $t('取 消') }}
        </el-button>
        <el-button id="idhLvrdc" @click="addUser" class=" defBord  " type="primary" :loading="loading">{{ $t('确 定') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js';
export default {
  components: {},
  data() {
    return {
      form: {
        "name": "",
        "rate": "",
        "category_id": []
      },
      storeList: [],
      dialogVisible: true,
      formRules: {},
      formLabelWidth: '120px',
      loading: false,
      extistCategory:null,
    };
  },
  props: ['open_tax_add'],
  created() {
    this.getData();
  },
  watch: {},
  mounted() { },
  methods: {
    getData() {
      SupplierApi.addGetTaxRate({}, true)
        .then(data => {
          this.storeList = data.data.storeList;
          this.extistCategory = data.data.extistCategory.map(Number);
        })
        .catch(error => { });
    },
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeTaxRateDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeTaxRateDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    addUser() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          SupplierApi.saveTaxRate(form).then(data => {
            self.loading = false;
            self.$message({
              message: self.$t('添加成功'),
              type: 'success'
            });
            self.dialogFormVisible(true);
          }).catch(error => {
            self.loading = false;
          });
        }
      });
    },
  },
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/buildStore/goods/taxrate/Add.vue